import React, { useState } from 'react';
export default function WelcomeImage({ src, alt, ...props }) {
  const [failedSource, setFailedSource] = useState(null);
  if (failedSource === src) return <span role="img" aria-label={alt || 'Welcome image'} className="inline-flex items-center justify-center rounded-xl border border-bookish-purple/30 bg-bookish-cream p-4 text-sm text-bookish-purple">Image unavailable</span>;
  return <img {...props} src={src} alt={alt} onError={() => setFailedSource(src)} />;
}
